import '../less/styles.less';
require('slick-carousel');

//remove this if http://caniuse.com/#feat=picture goes to 95%+ (not the case as of 2016-09-21)
require('picturefill');
require('jquery-validation');
require('jquery.easing');

require('./modules/image-tools.js');
require('./modules/youtube-link.js');
require('./modules/gdpr.js');
require('./modules/tiny-slider.js');
require('./modules/modernizr.js');

window.MobileDetect = new (require('mobile-detect'))(window.navigator.userAgent);
require('./parts/gallery.js');
require('./parts/utils.js');
require('./parts/slider.js');
require('./parts/menu.js');
require('./parts/sticky-header.js');
require('./parts/go-up-button.js');
require('./parts/fixed-nav-arrows.js');